import React from 'react';
import PropTypes from 'prop-types';
import { lifecycle } from 'recompose';
import { isEqual } from 'lodash';
import classnames from 'classnames';

import { FormFieldError, RadioGroup as SharedRadioGroup } from 'shared/components';

import requestStatuses from 'modules/common/constants/requestsStatuses';
import { checkErrorStatus, isErrorCode } from './checkError';

import theme from './FormStyles.scss';

const propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    value: PropTypes.any,
    name: PropTypes.string,
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    pristine: PropTypes.bool,
    submitFailed: PropTypes.bool,
  }).isRequired,
  errorMessagesMap: PropTypes.object,
  defaultValue: PropTypes.string,
  label: PropTypes.object,
  labelSuffix: PropTypes.any,
  rootClassName: PropTypes.string,
  tooltipType: PropTypes.oneOf(['text', 'hint', 'intl']),
  tooltipTestId: PropTypes.string,
  tooltipSize: PropTypes.string,
  tooltipPlacement: PropTypes.string,
};

const defaultProps = {
  errorMessagesMap: {},
  defaultValue: '',
  label: null,
  labelSuffix: null,
  rootClassName: '',
  tooltipType: undefined,
  tooltipTestId: null,
  tooltipSize: 'medium',
  tooltipPlacement: 'topStart',
};

export const RadioGroup = (props) => {
  const {
    input,
    meta: { error },
    defaultValue,
    errorMessagesMap,
    tooltipType,
    tooltipTestId,
    tooltipSize,
    tooltipPlacement,
    rootClassName,
    ...rest
  } = props;

  const errorMessage = !isErrorCode(error)
    ? { defaultMessage: error, id: 'default' }
    : error && errorMessagesMap[error];

  const errorStatus = checkErrorStatus(props.meta);

  return (
    <div className={ classnames(theme.root, rootClassName) }>
      <SharedRadioGroup
        { ...input }
        { ...rest }
        defaultValue={ input.value || defaultValue }
        onChange={ (value) => {
          input.onChange(value);
        } }
        status={ errorStatus
          ? requestStatuses.failure
          : requestStatuses.default
        }
      />
      <If condition={ errorStatus && errorMessage }>
        <FormFieldError
          tooltipType={ tooltipType }
          testId={ tooltipTestId }
          tooltipSize={ tooltipSize }
          tooltipMessage={ errorMessage }
          tooltipPlacement={ tooltipPlacement }
        />
      </If>
    </div>
  );
};

RadioGroup.propTypes = propTypes;
RadioGroup.defaultProps = defaultProps;

export default lifecycle({
  shouldComponentUpdate(nextProps) {
    return !isEqual(this.props.input, nextProps.input) || !isEqual(this.props.meta, nextProps.meta);
  },
})(RadioGroup);
